import { t } from "@/lib/localization";
import type { MediaAspect } from "@/lib/utils/lomdaV3/types";

export const MEDIA_ASPECTS: MediaAspect[] = ["auto", "16:9", "4:3", "1:1"];

export const aspectLabel = (aspect: MediaAspect) =>
    aspect === "auto" ? t("lomda-v3-editor.media.aspect-auto") : aspect;
